<!--<InfoBubble value="STERN.de" color="pink" isFilled:'true'></InfoBubble>-->
<template>
  <div class="infoBubble"
       :class="{filled : isFilled,  red: color === 'red', blue: color === 'blue', pink: color === 'pink', white: color === 'white', pointer: this.$listeners.click}"
       @click="$emit('click')">
    <span class="centerText">{{ value }}</span>
    <span class="centerText"><slot></slot></span>
    <span v-if="icon" :class="[icon, 'icon']" :style="[{color: iconColor}, iconStyle]"
          @click="$emit('iconClick')" v-tooltip.top="iconHover"></span>
    <span v-if="!disabled" @click="deleteSelf" class="close icon-close" :style="{ color:  closeColor}"></span>
  </div>
</template>

<script>
export default {
  name: "InfoBubble",
  data: function () {
    return {}
  },
  props: {
    value: [String, Number],
    color: {
      validator: function (value) {
        // The value must match one of these strings
        return ['pink', 'blue', 'red', 'white'].indexOf(value) !== -1
      }
    },
    isFilled: Boolean,
    icon: String,
    iconColor: String,
    iconStyle: [String, Object],
    iconHover: String,
    disabled: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    closeColor: function () {
      return this.isFilled ? "fff" : this.color;
    }
  },
  methods: {
    deleteSelf: function () {
      this.$emit("bubbleDeleted", this.value);
      this.$destroy();
      this.$el.parentNode.removeChild(this.$el);
    }
  }
}
</script>

<style lang="scss" scoped>
.infoBubble {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  border-radius: 100px;
  width: fit-content;
  padding: 1px 10px;
  font-size: 0.8em;
  margin: 0 5px 5px 0;
  border: 1px solid transparent;
  cursor: default;
  position: relative;
}

.infoBubble img {
  height: 0.8em;
  margin-left: 5px;
}

.pink {
  color: $pink;
  border-color: $pink;
}

.blue {
  color: $blue;
  border-color: $blue;
}

.white {
  color: white;
  border-color: white;
}

.red {
  color: $red;
  border-color: $red;
}

.filled {
  color: white;
}

.filled.pink {
  background: $pink;
}

.filled.blue {
  background: $blue;
}

.filled.red {
  background: $red;
}

.filled.white {
  color: $darkGrey;
  background: white;
}

.pointer {
  cursor: pointer;
}

.close {
  font-size: .5rem;
  margin-left: .4rem;
  cursor: pointer;
}

.icon {
  margin-left: .3rem;
}

.centerText {
  text-align: center;
}
</style>